// extracted by mini-css-extract-plugin
export default {"infoContainer":"Contact_infoContainer__D7F1f","links":"Contact_links__b+iNT","link":"Contact_link__uD0KR"};